import { useEffect, useRef, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { invalidateCrmResourceQueries } from '@/lib/queryClient';

interface RealTimeMessage {
  event?: string;
  type?: string;
  payload?: { type?: string };
}

/** Canonical owner-scoped realtime invalidation channel. */
export function useOwnerRealtimeInvalidation() {
  const [isConnected, setIsConnected] = useState(false);
  const wsRef = useRef<WebSocket | null>(null);
  const queryClient = useQueryClient();

  useEffect(() => {
    // Configura connessione WebSocket
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const wsUrl = `${protocol}//${window.location.host}/ws`;
    
    
    try {
      const ws = new WebSocket(wsUrl);
      wsRef.current = ws;

    ws.onopen = () => {
      setIsConnected(true);
    };

    ws.onmessage = (event) => {
      try {
        const message: RealTimeMessage = JSON.parse(event.data);
        
        if (message.event === 'new_email') {
          // Invalida la cache delle email per ricaricarle
          queryClient.invalidateQueries({ queryKey: ['/api/emails'] });
        }
        if (message.type === 'cache_invalidation') {
          const resource = message.payload?.type;
          if (resource === 'emails' || resource === 'contacts' || resource === 'companies' || resource === 'deals' || resource === 'tasks' || resource === 'meetings') {
            void invalidateCrmResourceQueries(queryClient, resource);
          }
        }
      } catch (error) {
        console.error('❌ [WebSocket] Errore parsing messaggio:', error);
      }
    };

    ws.onclose = () => {
      setIsConnected(false);
    };

    ws.onerror = (error) => {
      console.error('❌ [WebSocket] Errore connessione:', error);
      setIsConnected(false);
    };

    } catch (error) {
      console.error('❌ [WebSocket] Errore creazione WebSocket:', error);
      setIsConnected(false);
    }

    // Cleanup al dismount del componente
    return () => {
      if (wsRef.current) {
        wsRef.current.close();
      }
    };
  }, [queryClient]);

  return { isConnected };
}

export const useRealTimeEmails = useOwnerRealtimeInvalidation;
